import { useState } from 'react';
import logoUrl from '@/assets/logo.jpg';
import { auth } from '@/api/endpoints';
import { errorMessage } from '@/api/client';
import { setSession, type SessionUser } from '@/auth/session';
import { Button, ErrorBox, Form, Input } from '@/components/ui';
import { required } from '@/utils/format';

export function RegisterScreen({
  onSuccess,
  onLogin,
}: {
  onSuccess: (user: SessionUser) => void;
  onLogin: () => void;
}) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit() {
    const miss = required({ name, phone, password }, ['name', 'phone', 'password']);
    if (miss) {
      setError(miss);
      return;
    }
    if (password.length < 10) {
      setError('كلمة المرور يجب أن تكون 10 أحرف على الأقل.');
      return;
    }
    setLoading(true);
    setError('');
    const res = await auth.register({ name, phone, password });
    setLoading(false);
    if (!res.success) {
      setError(errorMessage(res));
      return;
    }
    const token = typeof res.token === 'string' ? res.token : '';
    const user = (res.user && typeof res.user === 'object' ? res.user : null) as SessionUser | null;
    if (token && user) {
      setSession(token, user);
      onSuccess(user);
      return;
    }
    const loginRes = await auth.login({ phone, password });
    if (!loginRes.success) {
      setError(errorMessage(loginRes, 'تم إنشاء الحساب. سجّل الدخول يدوياً.'));
      onLogin();
      return;
    }
    const t = typeof loginRes.token === 'string' ? loginRes.token : '';
    const u =
      loginRes.user && typeof loginRes.user === 'object' ? (loginRes.user as SessionUser) : null;
    if (!t || !u) {
      setError('تم التسجيل. سجّل الدخول يدوياً.');
      onLogin();
      return;
    }
    setSession(t, u);
    onSuccess(u);
  }

  return (
    <main className="auth-layout">
      <section className="auth-card">
        <div className="brand-row centered">
          <img src={logoUrl} className="brand-logo" alt="اشحنلي" />
          <div>
            <h1>اشحنلي وحدات</h1>
            <p>إنشاء حساب جديد</p>
          </div>
        </div>
        <Form className="form-grid" onSubmit={() => void submit()}>
          <Input label="الاسم" value={name} onChange={(e) => setName(e.target.value)} required />
          <Input
            label="رقم الهاتف"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            inputMode="tel"
            required
          />
          <Input
            label="كلمة المرور (10+)"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error ? <ErrorBox message={error} /> : null}
          <Button type="submit" disabled={loading}>
            {loading ? 'جاري الإنشاء…' : 'تسجيل'}
          </Button>
          <Button type="button" variant="secondary" onClick={onLogin}>
            لدي حساب بالفعل
          </Button>
        </Form>
      </section>
    </main>
  );
}
